import callHttp from "./axoisService";
import {METHOD_TYPE} from "../constants";

export const getTokenAuth = async (secretKey,thunkApi) => {
  return await callHttp('setCSRFToken', METHOD_TYPE.post,null,secretKey,null,thunkApi,null,false)
};
